import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DataStorageService } from 'src/app/shared/servizi/data-storage.service';
import { DbClicService } from 'src/app/shared/servizi/posizioni/posizioni_db-clic.service';
import { SpinnerService } from 'src/app/shared/servizi/spinner/spinner.service';

@Component({
  selector: 'app-distanza-meronimia',
  templateUrl: './distanza-meronimia.component.html',
  styleUrls: ['./distanza-meronimia.component.css']
})
export class DistanzaMeronimiaComponent implements OnInit {
  @Input() cy: any;
  @Input() arrayMeronimia: any[];
  @Input() arrayEdge: any[];
  @Input() statoNodiMero: [] = [];
  @Input() statoEdgeMero: any[];

  relationType;
  // array meronimi
  arrayMero: any[] = [];
  // array olonimi
  arrayOlo: any[] = [];

  valoreFormMero;
  valoreFormOlo;

  @Output() invioArrayMeronimia = new EventEmitter<any[]>();
  @Output() invioStato = new EventEmitter<[]>();
  // meronimia
  @Output() valoreFormMeron = new EventEmitter<number>();
  // olonimia
  @Output() valoreFormOlon = new EventEmitter<number>();
  // evento per disabilitare form distanza relazione meronimia
  @Output() disabilitoMero = new EventEmitter<boolean>();
  @Output() disabilitoOlo = new EventEmitter<boolean>();

  // evento per disabilitare form distanza relazione iponimia
  @Output() disabilitoIpo = new EventEmitter<boolean>();
  @Output() disabilitoIpe = new EventEmitter<boolean>();

  // iponimia
  @Output() valoreFormIpom = new EventEmitter<number>();
  // iperonimia
  @Output() valoreFormIper = new EventEmitter<number>();

  // differenzio stato olonimi e stato meronimi per avere controllo per la disabilitazione del form
  statoOlonimi;
  statoMeronimi;

  statoDistMero;
  statoDistOlo;

  constructor(
    private dataStorageService: DataStorageService,
    private spinner: SpinnerService,
    private dbClic: DbClicService
  ) { }

  ngOnInit(): void {
  }

  valoreFormMeronimia($event) {
    const that = this;
    sessionStorage.getItem('focusNode');
    // stato meronimi
    that.statoMeronimi = JSON.parse(sessionStorage.getItem("statoMeronimi"));
    // stato unico relazione meronimia (sia olonimi che meronimi)
    that.statoNodiMero = JSON.parse(sessionStorage.getItem("statoNodiMero"));
    that.statoEdgeMero = JSON.parse(sessionStorage.getItem("statoEdgeMero"));
    // stato distanza
    that.statoDistMero = JSON.parse(sessionStorage.getItem("statoDistMero"));
    let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    this.valoreFormMero = $event;
    // array meronimi
    that.arrayMeronimia = [];
    // array relazione di meronimia unico (sia olonimi che meronimi)
    this.arrayEdge = [];
    that.arrayMero = [];

    that.spinner.showSpinner();
    if (this.valoreFormMero === 0 && this.valoreFormOlo === 0) {
      // se non è stata selezionata la distanza
      // il nodo focus è al centro del viewport
      this.cy.center(elemSessionStorage);
      this.cy.zoom({
        level: 1,
        position: elemSessionStorage.position()
      });
    }
        // resetto stato se il form è 0 
        if (this.valoreFormMero === 0) {
          sessionStorage.removeItem('statoNodiMero');
          sessionStorage.removeItem('statoEdgeMero');
          let meronimiVisib = elemSessionStorage.incomers();
          // rimuovo edge
          this.cy.remove(meronimiVisib);
          // rimuovo nodi
          this.cy.remove(meronimiVisib.sources());
          that.spinner.hideSpinner();
        } else {
          this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'partMeronym', this.valoreFormMero, 'incoming').subscribe(meronimo => {
            if (meronimo) {
              that.spinner.hideSpinner();
            }
            sessionStorage.setItem("statoDistMero", JSON.stringify(meronimo.nodes.length));
            let nodi: any = meronimo.nodes;
            let edges = meronimo.edges;
            this.valoreFormMeron.emit(this.valoreFormMero);
            // se non ci sono sensi recuperati, disabilito il form solo se lo stato è null
            if (nodi.length === 0 && that.statoMeronimi === null) {
              this.valoreFormMeron.emit(0);
              this.disabilitoMero.emit(true);
              that.arrayMero.length = that.arrayMero.push(nodi.length);
              that.arrayMeronimia = that.arrayMero.concat(that.arrayOlo);
              // stato meronimi
              sessionStorage.setItem("statoMeronimi", JSON.stringify(this.arrayMero.length));
              // stato relazione di meronimia unico (sia olonimi che meronimi)
              sessionStorage.setItem("statoNodiMero", JSON.stringify(this.arrayMeronimia.length));
              that.invioArrayMeronimia.emit(that.arrayMeronimia);
              that.invioStato.emit(that.statoNodiMero);
            }
            let meronimiVisib = elemSessionStorage.predecessors().filter(':visible');
            // controllo per chiudere eventuali nodi visibili con lenght superiore a valore form
            for (var i = 0; i < meronimiVisib.length; i++) {
              if (meronimiVisib[i] !== meronimo.edges[i]) {
                // rimuovo edge
                this.cy.remove(meronimiVisib);
                // rimuovo nodi
                this.cy.remove(meronimiVisib.sources());
              }
            }
            // nodi > 1000
            if (nodi.length > 1000) {
              alert('attenzioni nodi > 1000, il caricamento dei sensi viene fermato')
              that.spinner.hideSpinner();
              // resetto valore a 0 
              this.valoreFormMeron.emit(0);
              // nodi < 1000
            } else {
              for (var i = 0; i < nodi.length; i++) {
                // aggiungo nodi
                this.cy.add([{
                  group: "nodes",
                  data: {
                    id: meronimo.nodes[i].data.id,
                    label: meronimo.nodes[i].data.label
                  }
                }]);
      
                that.arrayMero.length = that.arrayMero.push(meronimo.nodes[i].data.id);
                that.arrayMeronimia = that.arrayMero.concat(that.arrayOlo);
                // stato relazione di meronimia unico (sia olonimi che meronimi)
                sessionStorage.setItem("statoNodiMero", JSON.stringify(this.arrayMeronimia.length));
                // stato meronimi
                sessionStorage.setItem("statoMeronimi", JSON.stringify(this.arrayMero.length));
                that.invioArrayMeronimia.emit(that.arrayMeronimia);
                that.invioStato.emit(that.statoNodiMero);
                let nodiMero = that.cy.getElementById(meronimo.nodes[i].data.id);
                that.cy.batch(function () {
                  nodiMero
                    .style('display', 'element')
                    .addClass('label')
                    .addClass('meronimia')
                    ;
                });
              }
              for (var i = 0; i < edges.length; i++) {
                // aggiungo edge
                this.cy.add([{
                  group: "edges",
                  data: {
                    id: meronimo.edges[i].data.id,
                    source: meronimo.edges[i].data.source,
                    target: meronimo.edges[i].data.target,
                    relationType: meronimo.edges[i].data.relationType,
                    label: meronimo.edges[i].data.relationType
                  }
                }]);
                this.arrayEdge.length = this.arrayEdge.push(this.cy.getElementById(meronimo.edges[i].data.id));
                sessionStorage.setItem("statoEdgeMero", JSON.stringify(that.arrayEdge.length));
                let edgesMero = that.cy.getElementById(meronimo.edges[i].data.id);
                that.cy.batch(function () {
                  edgesMero
                    .style('display', 'element')
                    .addClass('edges')
                    ;
                });
              }
              //  servizio posizionamento
              that.dbClic.posizioneFormDistanza(elemSessionStorage);
              // controllo se il grafo è fuori dal viewport faccio fit
              if (that.isGraphOutOfView() === true) {
                that.cy.fit();
              }
            }
          });
        }
  }

  valoreFormOlonimia($event) {
    const that = this;
    sessionStorage.getItem('focusNode');
    // stato olonimi
    that.statoOlonimi = JSON.parse(sessionStorage.getItem("statoOlonimi"));
    // stato unico relazione meronimia (sia olonimi che meronimi)
    that.statoNodiMero = JSON.parse(sessionStorage.getItem("statoNodiMero"));
    that.statoEdgeMero = JSON.parse(sessionStorage.getItem("statoEdgeMero"));
    // stato distanza
    that.statoDistOlo = JSON.parse(sessionStorage.getItem("statoDistOlo"));
    let elemSessionStorage = this.cy.getElementById(sessionStorage.getItem('focusNode'));
    // array olonimi
    that.arrayOlo = [];
    // array relazione di meronimia unico (sia olonimi che meronimi)
    that.arrayMeronimia = [];
    this.arrayEdge = [];
    this.valoreFormOlo = $event;

    that.spinner.showSpinner();

    if (this.valoreFormMero === 0 && this.valoreFormOlo === 0) {
      // se non è stata selezionata la distanza
      // il nodo focus è al centro del viewport
      this.cy.center(elemSessionStorage);
      this.cy.zoom({
        level: 1,
        position: elemSessionStorage.position()
      });
    }
        // resetto stato se il form è 0 
        if (this.valoreFormOlo === 0) {
          sessionStorage.removeItem('statoNodiMero');
          sessionStorage.removeItem('statoEdgeMero');
          let olonimiVisib = elemSessionStorage.outgoers();
          // rimuovo edge
          this.cy.remove(olonimiVisib);
          // rimuovo nodi
          this.cy.remove(olonimiVisib.targets());
          that.spinner.hideSpinner();
        } else {

          this.dataStorageService.fetchSubGraph(sessionStorage.getItem('focusNode'), 'partMeronym', this.valoreFormOlo, 'outgoing').subscribe(olonimo => {
            if (olonimo) {
              that.spinner.hideSpinner();
            }
            sessionStorage.setItem("statoDistOlo", JSON.stringify(olonimo.nodes.length));
            let nodi: any = olonimo.nodes;
            let edges = olonimo.edges;
            this.valoreFormOlon.emit(this.valoreFormOlo);
            // se non ci sono sensi recuperati, disabilito il form, solo se lo stato è null
            if (nodi.length === 0 && that.statoOlonimi === null) {
              this.valoreFormOlon.emit(0);
              this.disabilitoOlo.emit(true);
              that.arrayOlo.length = that.arrayOlo.push(nodi.length);
              that.arrayMeronimia = that.arrayOlo.concat(that.arrayMero);
              // stato olonimi
              sessionStorage.setItem("statoOlonimi", JSON.stringify(this.arrayOlo.length));
              // stato relazione di meronimia unico (sia olonimi che meronimi)
              sessionStorage.setItem("statoNodiMero", JSON.stringify(this.arrayMeronimia.length));
              that.invioArrayMeronimia.emit(that.arrayMeronimia);
              that.invioStato.emit(that.statoNodiMero);
            }
            let olonimiVisib = elemSessionStorage.successors().filter(':visible');
            // controllo per chiudere eventuali nodi visibili con lenght superiore a valore form
            for (var i = 0; i < olonimiVisib.length; i++) {
              if (olonimiVisib[i] !== olonimo.edges[i]) {
                // rimuovo edge
                this.cy.remove(olonimiVisib);
                // rimuovo nodi
                this.cy.remove(olonimiVisib.targets());
              }
            }
            // nodi > 1000
            if (nodi.length > 500) {
              alert('attenzioni nodi > 1000, il caricamento dei sensi viene fermato')
              that.spinner.hideSpinner();
              // resetto valore a 0 
              this.valoreFormOlon.emit(0);
              // nodi < 1000
            } else {
              for (var i = 0; i < nodi.length; i++) {
                // aggiungo nodi
                this.cy.add([{
                  group: "nodes",
                  data: {
                    id: olonimo.nodes[i].data.id,
                    label: olonimo.nodes[i].data.label
                  }
                }]);
                that.arrayOlo.length = that.arrayOlo.push(olonimo.nodes[i].data.id);
                that.arrayMeronimia = that.arrayMero.concat(that.arrayOlo);
                // stato olonimi
                sessionStorage.setItem("statoOlonimi", JSON.stringify(this.arrayOlo.length));
                // stato relazione di meronimia unico (sia olonimi che meronimi)
                sessionStorage.setItem("statoNodiMero", JSON.stringify(this.arrayMeronimia.length));
                that.invioArrayMeronimia.emit(that.arrayMeronimia);
                that.invioStato.emit(that.statoNodiMero);
                let nodiOlo = that.cy.getElementById(olonimo.nodes[i].data.id);
                that.cy.batch(function () {
                  nodiOlo
                    .style('display', 'element')
                    .addClass('label')
                    .addClass('meronimia')
                    ;
                });
              }
      
              for (var i = 0; i < edges.length; i++) {
                // aggiungo edge
                this.cy.add([{
                  group: "edges",
                  data: {
                    id: olonimo.edges[i].data.id,
                    source: olonimo.edges[i].data.source,
                    target: olonimo.edges[i].data.target,
                    relationType: olonimo.edges[i].data.relationType,
                    label: olonimo.edges[i].data.relationType
                  }
                }]);
                this.arrayEdge.length = this.arrayEdge.push(this.cy.getElementById(olonimo.edges[i].data.id));
                sessionStorage.setItem("statoE", JSON.stringify(that.arrayEdge.length));
                let edgesOlo = that.cy.getElementById(olonimo.edges[i].data.id);
                that.cy.batch(function () {
                  edgesOlo
                    .style('display', 'element')
                    .addClass('edges')
                    ;
                });
              }
              //  servizio posizionamento
              that.dbClic.posizioneFormDistanza(elemSessionStorage);
              // controllo se il grafo è fuori dal viewport faccio fit
              if (that.isGraphOutOfView() === true) {
                that.cy.fit();
              }
            }
          });
        }
  }
  isGraphOutOfView() {
    const width = this.cy.width();
    const height = this.cy.height();
    const rbb = this.cy.elements().renderedBoundingbox();

    return rbb.x1 < 0 || rbb.y1 < 0 || rbb.x2 > width || rbb.y2 > height;
  }
}
